import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import EditStripeContactInfoModal from './component';
import { getIreneDashboard, updateStripeLandlordEmailAndPhoneNumber } from '@rental-manager/actions/requests';
import { closeNotification, showModalNotification, showPageNotification } from '@common/actions/NotificationActions';
import { DEFAULT_ERROR, STRIPE_CONTACT_INFO_UPDATE } from '@rental-manager/constants/NotificationConstants';
import { checkRequestActionSuccess, getSignInPage } from '@common/paymentsUtils/api';
import HTTP_STATUS from '@common/constants/HttpConstants';
import { ErrorInterface } from '@common/types';
import { logError } from '@zg-rentals/log-error';

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onSubmit: async ({ emailAddress, phoneNumber }) => {
    try {
      // Close any open banners
      await dispatch(closeNotification());

      // Request to update the tenant info
      const updateLandlordInfoResponse = await dispatch(
        updateStripeLandlordEmailAndPhoneNumber({
          propertyId,
          email: emailAddress,
          phone: phoneNumber,
        }),
      );
      await checkRequestActionSuccess(updateLandlordInfoResponse);

      // Request the latest landlord status
      const [landlordStatusResponse] = await dispatch(getIreneDashboard({ propertyId }));
      await checkRequestActionSuccess(landlordStatusResponse);

      // Navigate to dashboard
      await dispatch(push(baseUrl));

      // Show a success banner
      await dispatch(showPageNotification(STRIPE_CONTACT_INFO_UPDATE));

      return { error: false };
    } catch (err) {
      const error = err as ErrorInterface;
      if (error.action && error.action.payload) {
        const { status } = error.action.payload;

        // If 401 status, redirect to sign-in
        if (status === HTTP_STATUS.SC_UNAUTHORIZED) {
          window.location = getSignInPage();
          return null;
        }
      }

      logError({ error: err });
      dispatch(showModalNotification(DEFAULT_ERROR));
      return { error: true };
    }
  },
});

export default connect(null, mapDispatchToProps)(EditStripeContactInfoModal);
